import { KybManagementPanel } from '../components/KybManagementPanel';
import { ManagementPageLayout } from '../components/management/ManagementPageLayout';
import { useAuth } from '../hooks/useAuth';
import { usePageTitle } from '../hooks/usePageTitle';
import { canAccessAdminPages } from '../utils/roleUtils';

export function KybManagementPage() {
  const [authState] = useAuth();
  usePageTitle('KYC/KYB Management | Publishing Portal');

  return (
    <ManagementPageLayout authState={authState} canAccess={canAccessAdminPages}>
      <KybManagementPanel />
    </ManagementPageLayout>
  );
}
